import { render, staticRenderFns } from "./LmUsersPassword.vue?vue&type=template&id=0b5657b0&"
import script from "./LmUsersPassword.vue?vue&type=script&lang=js&"
export * from "./LmUsersPassword.vue?vue&type=script&lang=js&"
import style0 from "./LmUsersPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports